export const getTrainingProjects = async () => {
  try {
    const response = await fetch(
      `${process.env.GATSBY_PORTAL_API_URL}/channels/wvs-india-site?type=course`
    );

    const { projects } = await response.json();

    return { success: true, projects: projects };
  } catch (error) {
    console.error("Error fetching training projects:", error);
    return {
      success: false,
      error: "Something went wrong while trying to fetch trips",
    };
  }
};

export const getVolunteerProjects = async () => {
  try {
    const response = await fetch(
      `${process.env.GATSBY_PORTAL_API_URL}/channels/wvs-india-site?type=campaign,experience,research`
    );

    const { projects } = await response.json();

    return { success: true, projects: projects };
  } catch (error) {
    console.error("Error fetching volunteer projects:", error);
    return {
      success: false,
      error: "Something went wrong while trying to fetch trips",
    };
  }
};
